class HeroSlider {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('[data-slide-index]'));
    this.slideContents = Array.from(container.querySelectorAll('[data-slide-content]'));
    this.prevBtn = container.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = container.querySelector('.hero-slider__arrow--next');
    
    this.currentIndex = 0;
    this.autoplay = container.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(container.dataset.autoplayDelay) || 5000;
    this.fadeDuration = parseInt(container.dataset.fadeDuration) || 1000;
    this.autoplayTimer = null;
    this.isTransitioning = false;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    // Event listeners dla strzałek
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToPrev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToNext());
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.goToPrev();
      if (e.key === 'ArrowRight') this.goToNext();
    });

    // Touch/swipe support
    this.setupTouchHandlers();

    // Start autoplay if enabled
    if (this.autoplay) {
      this.startAutoplay();
      
      // Pause autoplay on hover
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
    }

    // Pause autoplay when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else if (this.autoplay) {
        this.startAutoplay();
      }
    });
  }

  goToNext() {
    if (this.isTransitioning) return;
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  goToPrev() {
    if (this.isTransitioning) return;
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  goToSlide(index) {
    if (index === this.currentIndex || this.isTransitioning) return;

    this.isTransitioning = true;

    const prevIndex = this.currentIndex;
    this.currentIndex = index;

    // Fade out current content and background simultaneously
    this.slideContents[prevIndex].classList.remove('opacity-100');
    this.slideContents[prevIndex].classList.add('opacity-0');
    this.slides[prevIndex].classList.remove('opacity-100');
    this.slides[prevIndex].classList.add('opacity-0');

    // Start fading in new background and content simultaneously (crossfade)
    this.slides[index].classList.remove('opacity-0');
    this.slides[index].classList.add('opacity-100');

    // Wait for fade to complete before switching content position
    setTimeout(() => {
      // Hide previous content completely
      this.slideContents[prevIndex].classList.add('absolute', 'top-0', 'left-0');
      
      // Show new content
      this.slideContents[index].classList.remove('absolute', 'top-0', 'left-0');
      this.slideContents[index].classList.remove('opacity-0');
      this.slideContents[index].classList.add('opacity-100');

      // Re-trigger animations for content
      this.triggerContentAnimations(index);
      
      this.isTransitioning = false;
    }, this.fadeDuration);

    // Reset autoplay timer
    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  triggerContentAnimations(index) {
    const content = this.slideContents[index];
    const heading = content.querySelector('.hero-slider__heading');
    const description = content.querySelector('.hero-slider__description');
    const button = content.querySelector('.hero-slider__button');
    const buttons = content.querySelector('.hero-slider__buttons');

    // Remove and re-add animation classes to retrigger
    [heading, description, button, buttons].forEach((el, i) => {
      if (el) {
        el.style.animation = 'none';
        // Force reflow
        void el.offsetWidth;
        el.style.animation = '';
      }
    });
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length <= 1) return;
    
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.goToNext();
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  setupTouchHandlers() {
    let touchStartX = 0;
    let touchEndX = 0;

    this.container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }

  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        this.goToNext();
      } else {
        // Swipe right - previous slide
        this.goToPrev();
      }
    }
  }

  destroy() {
    this.stopAutoplay();
    // Remove event listeners if needed
  }
}

// Initialize all hero sliders on the page
const initHeroSliders = () => {
  const heroSliderContainers = document.querySelectorAll('.hero-slider__container');
  
  heroSliderContainers.forEach(container => {
    new HeroSlider(container);
  });
};

export default initHeroSliders;
